import axios from 'axios';
import React, { useEffect, useState } from 'react'
import './billOfSupplyEntry.css'
import moment from 'moment'

// for date
var date = moment();
var currentDate = date.format('D/MM/YY');


const baseURL = localStorage.getItem('baseURL')

function DataEntry({setIsLoggedIn}) {

    const [data, updateData] = useState({
        "invoice": "BT/X/2022-23",
        "date": currentDate,
        "destination": "",
        "veh": "",
        "bags": "",
        "quantity": "",
        "rate": "",
        "amount": "",
        "item": "",
        "narration": ""
    });

    const handleDataUpdate = (e)=>{
        const val = e.target.value;
        const key = e.target.attributes['data-nam'].nodeValue;
        if (key=='rate'){
            const amount = Math.round((parseFloat(data.quantity)*parseFloat(val))*100)/100;
            updateData((data)=>({
                ...data,
                'amount' : amount
            }));
        } else if (key=='item'){
            const narr = `Beginning ${val} sale against vehicle no.: ${data.veh}`;
            updateData((data)=>({
                ...data,
                'narration' : narr
            }));
        }
        updateData((data)=>({
            ...data,
            [key] : val
        }))
    }

    const sendData = (e)=>{
        e.preventDefault();
        if (data==null || data==''){
            window.alert("Insert some data");
            return;
        }
        for (const key in data){
            if (data[key]==""){
                window.alert(`${key} is empty`);
                return;
            }
        }
        axios.post(baseURL+'/bills', {bos: data}, {headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('authToken')
        }}).then((response)=>{
            if (response.status!=200){
                console.log(response);
                window.alert('You are not logged-in');
                setIsLoggedIn(false);
            } else {
                const inputs = document.querySelectorAll('.billOfSupplyEntry form input');
                inputs.forEach(item=>item.value='')
                inputs[0].focus();
                updateData({
                    "invoice": "BT/X/2022-23",
                    "date": currentDate,
                    "destination": "",
                    "veh": "",
                    "bags": "",
                    "quantity": "",
                    "rate": "",
                    "amount": "",
                    "item": "",
                    "narration": ""
                });
                console.log(response.data.data);
                window.alert('Data Updated');
                localStorage.setItem("bos_data", JSON.stringify(response.data.data));
                window.location.href = './bos'
            }
        }).catch(err=>{
            console.log(err);
            window.alert('You are not logged-in');
            setIsLoggedIn(false);
        })
    }

    return (
        <section className='billOfSupplyEntry'>
            <p>Enter Details for Bill of Supply</p>
            <form onSubmit={sendData}>
                <div>
                    <label>Invoice No.</label>
                    <input value={data.invoice} data-nam='invoice' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Date</label>
                    <input value={data.date} placeholder='DD/MM/YY' data-nam='date' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Destination</label>
                    <input data-nam='destination' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Vehicle No.</label>
                    <input placeholder='XX/XXX/XXXX' data-nam='veh' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Bags</label>
                    <input data-nam='bags' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Quantity</label>
                    <input data-nam='quantity' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Rate</label>
                    <input data-nam='rate' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Amount</label>
                    <input value={data.amount} data-nam='amount' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Item</label>
                    <input data-nam='item' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Narration</label>
                    <input value={data.narration} data-nam='narration' onChange={handleDataUpdate} type="text"></input>
                </div>
                <button>Save</button>
            </form>
        </section>
        /* 
            bilty, date, veh, place
            bags, weight, bag wt, net wt
            rate, amount
        */
    )
}

export default DataEntry